import { appendData } from "Common/api/apiMiddleware.utils";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import axios from "axios";
import { NEW_DOCUMENT } from "../constants";
export default {
    importPreview: (file) => {
        const formData = new FormData();
        formData.append("File", file, file.name);
        return axios.post("/Documents/ImportPreview", formData);
    },
    saveDocument: (document, fileAttach, importParams) => {
        if (document.Type === DOCUMENT_TYPE.TABLE) {
            const formData = new FormData();
            if (fileAttach) {
                formData.append("File", fileAttach, fileAttach.name);
            }
            appendData(formData, document, "ViewModel");
            appendData(formData, importParams, "ViewModel.importParams");
            return axios.post("Table/SaveDocument", formData);
        }
        return axios.post("/Documents/SaveDocument", document);
    },
    duplicateDocument: (document) => axios.post("/Documents/DuplicateDocument", {
        DocumentId: document.Id,
        Data: { ...document, Id: NEW_DOCUMENT.Id }
    }),
    getDocument: (documentId) => axios.post("/Documents/GetDocument", { documentId }),
    getWorkSpaceProjects: (workSpaceId) => axios.post("/Projects/GetProjects", { workSpaceId })
};
